module.exports = __webpack_public_path__ + "img/yidong.4717eeb0.png";